'use strict';

//Require Modules
var $ = require('jquery'),
  Backbone = require('backbone'),
  logger = require('loglevel'),
  config = require('../../js/config'),
  mediator = require('../../js/mediator'),
  globalisation = require('../../utilities/globalisation'),
  ConfirmView = require('../../js/components/ConfirmView'),
  LoaderView = require('../Loader/LoaderView'),
  LoginView = require('../../js/session/views/LoginView'),
  designCenter = require('./design-center'),
  session = require('../../js/session/index'),
  LinkProjectsCollection = require('./LinkProjectsCollection'),

  EVENTS = {
    cancelled: 'cancelled',
    succeeded: 'succeeded',
    failed: 'failed'
  },
  URI_TYPES = {
    document: 'document',
    product: 'product'
  },
  STATE_CLASS = {
    confirming: 'DeleteFromProjectModal--confirming',
    loggedOut: 'DeleteFromProjectModal--loggedOut',
    loading: 'DeleteFromProjectModal--loading'
  };

Backbone.$ = $;

var DeleteFromProjectModalView = Backbone.View.extend({

  initialize: function(options) {
    options = options || {};
    this.projectId = options.projectId;
    this.uri = options.uri;
    this.uriType = options.uriType;

    this.initComponents();
    this.listenTo(this.confirmView, ConfirmView.EVENTS.confirmed, this.deleteFromProject);
    this.listenTo(this.confirmView, ConfirmView.EVENTS.cancelled, this.onCancel);

    this.listenTo(designCenter.projectsController.model, 'change', this.updateUiState, this);
    this.listenTo(session.sessionController.model, 'change', this.updateUiState, this);

    mediator.on(config.events.designCenter.documentProjectsSynced, this.syncSucceeded, this);
    mediator.on(config.events.designCenter.productProjectsSynced, this.syncSucceeded, this);
    mediator.on(config.events.designCenter.documentProjectsSyncFailed, this.syncFailed, this);
    mediator.on(config.events.designCenter.productProjectsSyncFailed, this.syncFailed, this);
  },

  tagName: 'section',
  className: 'DeleteFromProjectModal',
  projectId: '',
  uri: '',
  uriType: '',
  isDeletingFromProject: false,
  hasDeleteFailed: false,
  lastServerError: null,

  initComponents: function() {
    this.confirmView = new ConfirmView({
      headerText: globalisation.pluraliseAndTranslate('myProjects', 'deleteFromProjectHeader'),
      messageText: globalisation.pluraliseAndTranslate('myProjects', 'deleteFromProjectMessage'),
      confirmText: globalisation.pluraliseAndTranslate('myProjects', 'deleteFromProjectDelete')
    });
    this.loaderView = new LoaderView();
    this.loginView = new LoginView();
  },

  render: function() {
    this.$el
      .append(this.confirmView.el)
      .append(this.loaderView.el)
      .append(this.loginView.el);
    this.confirmView.render();
    this.loaderView.render();
    this.loginView.render();
    this.updateUiState();
    return this;
  },

  deleteFromProject: function() {
    this.isDeletingFromProject = true;
    this.hasDeleteFailed = false;
    this.lastServerError = null;
    var linkProjectsCollection = new LinkProjectsCollection([{
      id: this.projectId,
      state: LinkProjectsCollection.STATE.delete
    }]);
    switch (this.uriType) {
      case URI_TYPES.document:
        mediator.trigger(config.events.designCenter.syncDocumentProjects, this.uri, linkProjectsCollection);
        break;
      case URI_TYPES.product:
        mediator.trigger(config.events.designCenter.syncProductProjects, this.uri, linkProjectsCollection);
        break;
      default:
        logger.error('Invalid uriType specified', this.uriType);
    }
  },

  onCancel: function(e) {
    this.trigger(EVENTS.cancelled);
    if (e) e.preventDefault();
  },

  resetView: function() {
    this.confirmView.removeError();
    this.isDeletingFromProject = false;
    this.hasDeleteFailed = false;
    this.lastServerError = null;
  },

  updateUiState: function() {
    if (session.sessionController.isLoggedIn() === false) {
      this.showLoggedOutStateUi();
    } else {
      // We presume the user can delete a project and we'll handle a 401
      this.loginView.$el.hide();
      if (this.projectId) {
        if (this.isSyncing()) {
          this.showLoadingIndicatorUi();
        } else if (!this.isDeletingFromProject) {
          this.showConfirmUi();
        }
      } else {
        this.showConfirmUi();
      }
    }
  },

  isSyncing: function() {
    switch (this.uriType) {
      case URI_TYPES.document:
        return designCenter.projectsController.isSyncingDocumentProjects(this.uri);
      case URI_TYPES.product:
        return designCenter.projectsController.isSyncingProductProjects(this.uri);
      default:
        logger.error('Invalid uriType specified', this.uriType);
    }
  },

  setStateClass: function(stateClass) {
    this.$el
      .removeClass(STATE_CLASS.confirming)
      .removeClass(STATE_CLASS.loggedOut)
      .removeClass(STATE_CLASS.loading);
    this.$el.addClass(stateClass);
  },

  // If we know for sure the user is not logged in
  // we might want to change this logic so that we ping the authorize
  // endpoint if we don't know using `mediator.trigger(config.events.session.checkLoggedInState)`
  showLoggedOutStateUi: function() {
    this.setStateClass(STATE_CLASS.loggedOut);
    // These JS hide/show can be handled by CSS when it's built
    this.loginView.$el.show();
    this.confirmView.$el.hide();
    this.loaderView.$el.hide();
  },

  showLoadingIndicatorUi: function() {
    this.setStateClass(STATE_CLASS.loading);
    this.isDeletingFromProject = true;
    // These JS hide/show can be handled by CSS when it's built
    this.confirmView.$el.hide();
    this.loaderView.$el.show();
  },

  showConfirmUi: function() {
    this.setStateClass(STATE_CLASS.confirming);
    if (this.hasDeleteFailed && this.lastServerError) {
      this.confirmView.setError(this.lastServerError.get('title'));
    } else {
      this.confirmView.removeError();
    }
    this.confirmView.$el.show();
    this.loaderView.$el.hide();
    this.loginView.$el.hide();
  },

  syncFailed: function(uri, err) {
    if (this.isDeletingFromProject && uri === this.uri) {
      this.isDeletingFromProject = false;
      this.hasDeleteFailed = true;
      this.lastServerError = err;
      this.trigger(EVENTS.failed);
    }
    this.updateUiState();
  },

  syncSucceeded: function(uri) {
    if (uri === this.uri) {
      this.resetView();
      this.trigger(EVENTS.succeeded);
    }
  }

}, {
  EVENTS: EVENTS
});

module.exports = DeleteFromProjectModalView;



// WEBPACK FOOTER //
// ./assets/components/DesignCenter/DeleteFromProjectModalView.js